exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hamburger-icon{display:inline-block;width:4rem;height:2.3rem}@media (min-width:48em){.hamburger-icon{width:4.8rem;height:3rem}}.hamburger-icon .hamburger-svg{width:4rem;height:2.3rem}.hamburger-icon .hamburger-svg rect{fill:#fff;width:100%}@media (min-width:48em){.hamburger-icon .hamburger-svg{width:4.8rem;height:3rem}}@media (min-width:76.8em){.hamburger-icon:hover .hamburger-svg rect{fill:gray}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-HamburgerIcon/_index.scss
 ** module id = 187
 ** module chunks = 0
 **/